export default __webpack_public_path__ + "static/media/ST3_H.b5271278.png";